import { render, staticRenderFns } from "./FreeGift.vue?vue&type=template&id=a4cff66a&scoped=true&"
import script from "./FreeGift.vue?vue&type=script&lang=js&"
export * from "./FreeGift.vue?vue&type=script&lang=js&"
import style0 from "./FreeGift.vue?vue&type=style&index=0&id=a4cff66a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cff66a",
  null
  
)

export default component.exports